<script setup>
import { ref } from 'vue';

import IntentSettings from '../components/IntentSettings.vue';
import IntentMonitorTable from '../components/IntentMonitorTable.vue';

const props = defineProps({
  bot: {
    type: Object,
    required: true,
  },
});

const SUB_TABS = [
  {
    key: 'settings',
    labelKey: 'AI_AGENT.INTENT.SUB_TABS.SETTINGS',
    icon: 'i-lucide-sliders-horizontal',
  },
  {
    key: 'monitor',
    labelKey: 'AI_AGENT.INTENT.SUB_TABS.MONITOR',
    icon: 'i-lucide-activity',
  },
];

const activeSubTab = ref('settings');
</script>

<template>
  <div class="flex flex-col gap-5">
    <div
      class="inline-flex self-start gap-1 p-1 rounded-xl bg-n-alpha-1 outline outline-1 -outline-offset-1 outline-n-weak"
      role="tablist"
    >
      <button
        v-for="subTab in SUB_TABS"
        :key="subTab.key"
        type="button"
        role="tab"
        :aria-selected="activeSubTab === subTab.key"
        :data-testid="`intent-subtab-${subTab.key}`"
        class="flex items-center gap-2 px-3 py-1.5 rounded-lg text-button-small transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-n-brand motion-reduce:transition-none"
        :class="
          activeSubTab === subTab.key
            ? 'bg-n-solid-3 text-n-slate-12 shadow-sm'
            : 'text-n-slate-11 hover:text-n-slate-12'
        "
        @click="activeSubTab = subTab.key"
      >
        <span :class="subTab.icon" class="size-3.5" />
        {{ $t(subTab.labelKey) }}
      </button>
    </div>
    <IntentSettings v-if="activeSubTab === 'settings'" :bot="props.bot" />
    <IntentMonitorTable v-else :bot="props.bot" />
  </div>
</template>
